import { v4 as uuidv4 } from 'uuid';
import { BLOCK_TYPES, DECISION } from 'constants/jobs.constants';

export const prepareBlocksFromManifest = (diffManifest) => {
  const { diff, comments } = diffManifest;
  const rightPane = diff?.right_pane || [];
  const leftPane  = diff?.left_pane  || [];

  const commentMap = {};
  (comments || []).forEach((c) => { commentMap[c.element_id] = c; });

  let blocks = rightPane.map((item, index) => {
    const review = commentMap[item.element_id];
    return {
      id:              uuidv4(),
      element_id:      item.element_id,
      linked_id:       item.linked_id,
      content:         item.text,
      originalContent: item.text,
      originalIndex:   index,
      type:            review && review.decision === DECISION.REVIEW ? BLOCK_TYPES.NEEDS_WORK : BLOCK_TYPES.LOCKED,
      comment:         review && review.decision === DECISION.REVIEW ? review.comment : '',
      hasComment:      !!(review && review.decision === DECISION.REVIEW),
      isDeleted:       false,
      isGhost:         false,
    };
  });

  const ghostDecisions = (comments || []).filter(
    (d) => d.diff_type === DECISION.REMOVED && d.decision === DECISION.REVIEW,
  );

  ghostDecisions.forEach((ghost) => {
    const recoveredText = ghost.removed_text;
    if (!recoveredText) return;

    const ghostBlock = {
      id:              uuidv4(),
      element_id:      ghost.element_id,
      content:         recoveredText,
      originalContent: recoveredText,
      type:            BLOCK_TYPES.GHOST,
      comment:         ghost.comment,
      hasComment:      true,
      isDeleted:       false,
      isGhost:         true,
    };

    const ghostIdxInLeft = leftPane.findIndex((item) => item.element_id === ghost.element_id);

    if (ghostIdxInLeft > 0) {
      const prevNeighborId  = leftPane[ghostIdxInLeft - 1].element_id;
      const insertAfterIdx  = blocks.findIndex(
        (b) => b.linked_id === prevNeighborId || b.element_id === prevNeighborId,
      );
      if (insertAfterIdx !== -1) {
        blocks.splice(insertAfterIdx + 1, 0, ghostBlock);
      } else {
        blocks.push(ghostBlock);
      }
    } else {
      blocks.unshift(ghostBlock);
    }
  });

  return blocks;
};
